AdolopmentDataActions = require 'actions/adolopment_data_actions'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
EtdPart = require 'components/etd/etd_part'
EtdVotingMixin = require 'components/mixins/etd_voting_mixin'
Recommendation = require 'components/etd/recommendation'
Switcher = require 'components/common/switcher'
Translation = require 'components/mixins/translation'
{ getSelectedOptionFromSection } = require 'lib/etd_helper'

RecommendationPart = createReactClass
  displayName: 'RecommendationPart'
  mixins: [
    CustomRenderMixin
    Translation('es:recommendations.table')
    EtdVotingMixin
  ]

  propTypes:
    adolopments: PropTypes.instanceOf(Immutable.Map).isRequired
    adolopmentData: PropTypes.instanceOf(Immutable.Map).isRequired
    etdId: PropTypes.string.isRequired
    etdViewSettings: PropTypes.instanceOf(Immutable.Map).isRequired
    overarchingQuestionData: PropTypes.instanceOf(Immutable.Map)
    sectionId: PropTypes.string.isRequired
    showResultingDataOnly: PropTypes.bool
    switchVotingTab: PropTypes.func

  getDefaultProps: ->
    overarchingQuestionData: Immutable.Map()
    showResultingDataOnly: false

  _isConsensus: ->
    @props.activeTab? and @props.activeTab isnt 'draftJudgement'

  _getSectionProps: (section, sectionId) ->
    editable: if @props.editable? then @props.editable else @_inEditMode()
    etdId: @props.etdId
    etdViewSettings: @props.etdViewSettings
    isConsensus: @_isConsensus()
    overarchingQuestionData: @props.overarchingQuestionData
    renderMode: @props.renderMode
    sectionId: sectionId

  toggleAdolopmentForSection: ->
    AdolopmentDataActions.toggleAdolopmentForSection @props.etdId, 'conclusions', @props.sectionId

  render: ->
    {
      activeTab
      adolopmentData
      adolopments
      etdId
      etdViewSettings
      overarchingQuestionData
      renderMode
      section
      sectionId
      switchVotingTab
      titleKey
      showResultingDataOnly
    } = @props

    selectedOption = getSelectedOptionFromSection @_isConsensus(), section

    highlightAsDiff = if not adolopments.isEmpty()
      originalSection = adolopments.last()
        .getIn(['templateData', 'conclusions', 'sections', sectionId])
      originalOption = getSelectedOptionFromSection false, originalSection
      selectedOption != originalOption and not _.isEmpty(selectedOption)
    else false

    # withAdolopment means that one wants to update this section
    # if it is set to false than content of the section is copied from orginal etd and marked as
    # readonly
    withAdolopment = adolopmentData.getIn([sectionId, 'withAdolopment'], false)

    sectionProps = @_getSectionProps section, sectionId

    if section and not section.isEmpty()
      <EtdPart titleKey='type_of_recommendation'
        renderMode={renderMode}
        activeTab={activeTab}
        onTabClick={switchVotingTab}
      >
        {not adolopments.isEmpty() and renderMode isnt 'printout' and
          <div className="type_of_recommendation__adolopment-switcher">
            <Switcher
              checked={withAdolopment}
              onChange={@toggleAdolopmentForSection}
              buttonText={@i18n '/es:recommendations.table-view-options.toggle_adolopment'}
            />
          </div>
        }

        <Recommendation
          adolopmentData={adolopmentData}
          adolopments={adolopments}
          etdId={etdId}
          etdViewSettings={etdViewSettings}
          renderMode={renderMode}
          highlightAsDiff={highlightAsDiff}
          overarchingQuestionData={overarchingQuestionData}
          section={section}
          sectionId={sectionId}
          showResultingDataOnly={showResultingDataOnly}
          withTitle={false}
        />

        {if @_hasVotingStarted() and activeTab is 'votingResults'
          votingProps = if @_hasVotingStarted() then @_getVotingPropsForSection(sectionId) else {}

          <table className="standard-table recommendation-table-static">
            <TypeOfRecommendationWithVoting key={sectionId}
              section={section}
              {...sectionProps}
              {...votingProps}
            />
          </table>
        }
      </EtdPart>
    else
      null

module.exports = RecommendationPart
